import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'

const RouteDetailsItem = ({ icon, label, value }) => {
  return (
    <Grid container alignItems="center" sx={{ width: '100%' }}>
      <Grid sx={{ minWidth: '140px' }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {icon}
          <Typography color="textSecondary" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Grid>
      <Grid size="grow">
        <Typography>{value}</Typography>
      </Grid>
    </Grid>
  )
}

RouteDetailsItem.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.node,
  value: PropTypes.node,
}

export default RouteDetailsItem
